/**
 * Tab usability
 * This plugin adds a class to elements when they have tabfocus, which allows styling without the style applying to the :active state.
 * @version 3.0.0
 * @exports TabUsability
 */
export default class TabUsability {
    /**
     * Constructor
     * @public
     */
    constructor() {
        this._initEvents();
    }

    /**
     * Initiates events.
     * @private
     */
    _initEvents() {
        document.addEventListener('keyup', event => {
            let el = event.target,
                keyCode = event.keyCode ? event.keyCode : event.which;

            if (
                ['a', 'button', 'input', 'textarea', 'select'].indexOf(
                    el.tagName.toLowerCase()
                ) !== -1 ||
                (el.tagName.toLowerCase() === 'div' && el.classList.contains('carousel-cell')) &&
                keyCode === 9
            ) {
                el.classList.add('usability--tab-focus');
            }

            //Menu is last element, set focus om main after menu is done tabbing.
            var navLinks = document.querySelector('nav#mobile-menu').querySelectorAll('li a');
            var mainElement = document.querySelector("#main-content");
            var lastNavLink = navLinks[navLinks.length - 1]
            if (lastNavLink != undefined) {
                lastNavLink.addEventListener('keydown', (event) => {
                    if (event.key === 'Tab' && !event.shiftKey) {
                        mainElement.focus();
                        $(document).scrollTop(0);
                    }
                });
            }

            //Set focus om main-header to be able to get focus on menu/logo after we tabbed through profile secion elements and closed it.
            const profileSection = document.querySelector('#profile-section');
            const profileLinks = profileSection?.querySelectorAll('a');
            const profileLastLink = profileLinks?.length > 0 ? profileLinks[profileLinks.length - 1] : null;
            if (profileLastLink) {
                profileLastLink.addEventListener('keydown', (event) => {
                    if (event.key === 'Tab' && !event.shiftKey) {
                        profileSection.toggleAttribute('hidden', true);
                        document.getElementById('minimize-profile').setAttribute('aria-expanded', false);
                        document.querySelector('.main-header').setAttribute('tabIndex', -1);
                        document.querySelector('.main-header').focus();
                    }
                });
            }
        });

        document.addEventListener('click', event => {
            let el = event.target;

            if (['input', 'textarea'].indexOf(el.tagName.toLowerCase()) !== -1) {
                el.classList.add('usability--tab-focus');
            }
        });

        document.addEventListener(
            'blur',
            event => {
                let el = event.target;

                if (el.classList && el.classList.contains('usability--tab-focus')) {
                    el.classList.remove('usability--tab-focus');
                }
            },
            true
        );
    }
}
